import { SearchParams, withSearchParams } from '@ui/util';

import { SITES, SNAP_QUOTES } from './constants';

export const buildTeamUrl = ({
  siteUuid,
  teamUuid,
  path,
  queryParams,
}: {
  siteUuid: string;
  teamUuid: string;
  path?: string;
  queryParams?: SearchParams | null;
}) => {
  const base = `${SITES}/${siteUuid}/teams/${teamUuid}`;
  if (!path) {
    return withSearchParams(base, queryParams ?? null);
  }

  return withSearchParams(`${base}/${path}`, queryParams ?? null);
};

export const buildTeamSnapQuoteUrl = ({
  siteUuid,
  teamUuid,
  snapQuoteUuid,
  path,
}: {
  siteUuid: string;
  teamUuid: string;
  snapQuoteUuid: string;
  path?: string;
}) => {
  const base = buildTeamUrl({
    siteUuid,
    teamUuid,
    path: `${SNAP_QUOTES}/${snapQuoteUuid}`,
  });

  if (!path) {
    return base;
  }

  return `${base}/${path}`;
};
